export { useAddClient } from '@pages/Clients/AddClient/hooks/useAddClient';

export { ClientsTable } from '@pages/Clients/ClientsList/components/ClientsTable';

export { AddClient } from '@pages/Clients/AddClient/AddClient.main';
export { AddServiceCategory } from '@pages/Clients/AddServiceCategory';
export {
  ClientPaymentsHeader,
  ClientPaymentsList,
} from '@pages/Clients/ClientPayments';
export { ClientsExport } from '@pages/Clients/ClientsExport/ClientsExport.main';
export { ClientsList } from '@pages/Clients/ClientsList/ClientsList.main';
export { ClientsListHeader } from '@pages/Clients/ClientsList/components';
export { useClientsList } from '@pages/Clients/ClientsList/hooks';
export { EditClient } from '@pages/Clients/EditClient';
export {
  ClientServiceParams,
  ClientsServiceEmployees,
} from '@pages/Clients/EditClientService/components';
export { ImportFromExcel } from '@pages/Clients/ImportFromExcel';
export { DetachResponsibleFromLead } from '@pages/Clients/DetachResponsibleFromLead';
